import api from 'api/axiosInstance';
import { getLocationOrigin } from 'utils/helpers';
const returnUrl = `${getLocationOrigin(true)}/expenses`;

const getCustomerBillingPortal = (): Promise<any> =>
  api
    .get(`/v1/subscriptions/stripe/customer-portal?return_url=${returnUrl}`)
    .then(({ url }: any) => {
      window.location.href = url;

      return Promise.resolve();
    });

export default getCustomerBillingPortal;
